import React, { useCallback, useMemo, useRef, useState } from "react";
import Accordion from "../../CustomInvoices/WizardSteps/Accordion";
import Swal from "sweetalert2";
import Select from "react-select";
import PopOver from "../../global/PopOver";
import { useTranslation } from "react-i18next";
import { AppContext, getStore, useAppContext } from "../../../AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { selectStyle } from '../../../design/selectStyle';
import AsyncSelect from "react-select/async";
import mainAxios from '../../../services/mainAxios';
import func, { isObjectEmpty } from '../../../services/functions';
import { faPlus, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import selectStyle from "../../../design/selectStyle";
import { useEffect } from "react";
import InvoicePrintInfo from "../../global/InvoicePrintInfo";
import DatePicker from "react-datepicker";
import countries from "../../../services/countries.json";
import { Tooltip } from "primereact/tooltip";
import { partiesDialogTypes } from "../../../services/data";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import EditAddSupplies from "../../Setup/Contacts/EditAddContact";
import { debounce } from "lodash";



const PosDetails = ({posState, persistedData,setPersistedData,setPosState,branchesOptions, tcrList, disabled,printInvoice,isEditPos=false,hasNoCustomer, section}) => {
  const {  selectedCompany: [selectedCompany],user:[user],refreshStatuses } = useAppContext()
  const { t, i18n } = useTranslation('translations');
  const inputRef = React.useRef(null);
  const issueDateRef = React.useRef();
  const [minIssueDate, setMinIssueDate] = React.useState("");
  const { formatNumber } = func;
  const [partiesDialog,setPartiesDialog]=useState({open:false,id:null,party:null,contact:null})
  const [buyerInputValue, setBuyerInputValue] = useState("")
  const [buyerValue, setBuyerValue] = useState(null)
  const buyerVisible=partiesDialog.open && partiesDialog.party==partiesDialogTypes.buyer
  const [ rateBoaDate,setRateBoaDate ] = useState(null)
  const [ isUsingBoaRate, setIsUsingBoaRate ] = useState(false)
  const [ boaExchangeRate, setBoaExchangeRate ] = useState(null)
  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );
  const currenciesPos = [
    { label: "Lek", value: "ALL" },
    { label: "US Dollar", value: "USD" },
    { label: "Euro", value: "EUR" },
  ];

  const buyerIDTypes = [
    { label: "NUIS", value: "1" },
    { label: "ID", value: "2" },
    { label: "PASS", value: "3" },
    { label: "VAT", value: "4" },
  ];
  const buyerIDTypesParsed = [
    {label:t("table.empty"),value:null,name:null},
    { label: "NUIS", value: "1",name:"NUIS" },
    { label: "ID", value: "2",name:"ID" },
    { label: "PASS", value: "3",name:"PASS" },
    { label: "VAT", value: "4",name:"VAT" },
  ];

  let profileIdPos = [
    { "value": "P1", "label": "P1 - Invoicing the supply of goods and services ordered on a contract basis", "types": ["380", "388"] },
    { "value": "P2", "label": "P2 - Periodic invoicing of contract-based delivery", "types": ["380", "388", "82"] }
  ];

  if (isEditPos) profileIdPos.push({ "value": "P10", "label": "P10 - Corrective Invoicing", "types": ["384"] })


  const isRefreshStatus=useCallback((invoice)=>{
    let status = posState?.status?.status;
    let resendStatuses = refreshStatuses?.filter(resendStatus=>resendStatus?.isActive==true)?.map(resendStatus=>resendStatus?.status)?? []
    let staticRefreshConditions=invoice?.einvoice && invoice?.cisStatus==="SUCCESS" && (!invoice?.eic || invoice.eic=="")
    
    return  (resendStatuses.includes(status)) || staticRefreshConditions
},[refreshStatuses])

const getDefaultCustomer=() =>{
      const generalCustomer = {
      tin: "9999",
      name: t("pos.generalCustomer"),
      address: " ",
      country: "Albania",
      town: " ",
      type: "2",
    };

    mainAxios
      .post("apiEndpoint/search", {
        object: "GetConnections",
        value: null,
        params: {
          customerDefault: "true",
          company: selectedCompany
        },
      })
      .then((res) => {
        if (res?.data?.content?.length > 0) {
          let buyer = res.data.content[0];
          buyer = {
            ...buyer,
            label: buyer.name + " - " + buyer.idValue,
            value: buyer.name,
          }
          handleInvoiceBuyerChange(null, "buyer", buyer)
        }else{
          handleInvoiceBuyerChange(null, "buyer", generalCustomer);

        }
      }).catch(err=>{
          handleInvoiceBuyerChange(null, "buyer", generalCustomer);
      })
  }

    const loadOptionsForContacts = useCallback(debounce( async(name) => {
  
      const sortCriteria=[{
        field: "recordDate",
        direction: "DESC"
      }]
  
      let customers=[];
      if (name.length > 2) {
        return await mainAxios
        .post("/apiEndpoint/search", {
          object: "GetConnections",
          value: null,
          params: {
            customerLiveSearch:name,
            "contactTypes.type": "CUSTOMER"
          },
          sortCriteria
        })
          .then((res) => {
            if(res.data.status){
              customers = res.data.content.map((el) => {
                const {name,idValue:tin}=el
                return {
                  ...el,
                  label: name + " - " + tin,
                  value: name,
                };
              });
            }
  
            return customers;
          });
      }
      return await Promise.resolve([]);
    },200),[]);

  const handleFocus = (event) => event.target.select();


  // useEffect(() => {
  //   if (!isEditPos) getDefaultCustomer()
  // }, [])



  useEffect(() => {
    const generalCustomer = {
      tin: "99999",
      name: t("pos.generalCustomer"),
      address: " ",
      country: "Albania",
      town: " ",
      type: "2",
    };

    const isGeneralCustomer = (posState.parties.buyer?.tin?.length == 0 ||!posState.parties.buyer?.tin) && posState.parties.buyer?.name?.length == 0

    if (isGeneralCustomer && !hasNoCustomer) {
      handleInvoiceBuyerChange(null, "buyer", generalCustomer);
    }
  }, [posState.parties.buyer, hasNoCustomer])

  const prevLanguageRef = useRef(i18n.language);
  const prevGeneralCustomerNameRef = useRef(t("pos.generalCustomer"));
  useEffect(() => {
    if (prevLanguageRef.current === i18n.language) {
      return;
    }

    const isGeneralCustomerWithTin9999 = posState.parties.buyer?.tin === "9999" || posState.parties.buyer?.tin === "99999"
    const currentName = posState.parties.buyer?.name;
    const isCurrentNameGeneralCustomer = currentName === prevGeneralCustomerNameRef.current;

    if (isGeneralCustomerWithTin9999 && isCurrentNameGeneralCustomer) {
      const translatedName = t("pos.generalCustomer");
      setPosState((prevState) => ({
        ...prevState,
        parties: {
          ...prevState.parties,
          buyer: {
            ...prevState.parties.buyer,
            name: translatedName,
          },
        },
      }));
    }

    prevLanguageRef.current = i18n.language;
    prevGeneralCustomerNameRef.current = t("pos.generalCustomer");
  }, [i18n.language])

  useEffect(() => {
    const buyerName = posState?.parties?.buyer?.name;
    setBuyerInputValue(buyerName || "");

    if (buyerName) {
      const newValue = {
        label: buyerName,
        value: buyerName,
        name: buyerName
      };
      setBuyerValue(newValue);
    } else {
      setBuyerValue(null);
    }
  }, [posState?.parties?.buyer?.name, i18n.language])

  const getExchangeRates = () => {
    const selectedCurrencyCode = posState?.currency;
    mainAxios
      .post(`api/exchange-rates/getByCode?code=${selectedCurrencyCode}`,{})
      .then((res) => {
        const data = res?.data
        if (data) {
          const [year,month,day,hour,minute,second] = data.modifiedDate
          const date = moment({
            month: month - 1, year,day,hour,minute,second
          }).format("DD/MM/YYYY HH:mm:ss");

          setRateBoaDate(date)
          setBoaExchangeRate(data?.value);
          setIsUsingBoaRate(true);
          handleExchangeRateUpdate(data?.value);
        }
      }).catch((error) => {
        console.error('Error fetching exchange rate:', error);
      });
  };
  
  const isRateBoaDateDifferent = () => {
    const today = moment().format("DD/MM/YYYY H:mm:ss");
    return rateBoaDate && rateBoaDate != today;

  };

  const calculateRateDifference = () => {
    if (!boaExchangeRate || !posState?.rate) return null;

    const customRate = parseFloat(posState.rate);
    const boaRate = parseFloat(boaExchangeRate);

    if (isNaN(customRate) || isNaN(boaRate) || boaRate === 0) return null;

    const percentageDiff = ((customRate - boaRate) / boaRate) * 100;
    const isHigher = percentageDiff > 0;
    const absDiff = Math.abs(percentageDiff).toFixed(2);

    return {
      percentage: absDiff,
      isHigher: isHigher,
      direction: isHigher ? 'exchangeMore' : 'exchangeLess'
    };
  };

  const handleExchangeRateUpdate = (newRate) => {
    setPosState((prevState) => ({
      ...prevState,
      rate: newRate,
    }));
  };

  const handleIssueDateChange = (date) => {
    const dueDate = date > posState.dueDate ? "" : posState.dueDate;
    setPosState((posState) => ({
      ...posState,
      issueDate: date,
      dueDate,
    }));
    issueDateRef.current.setOpen(false);

    let today = new Date();
    let technicalErrorMinDate = func.dateBeforeSomeDays(1, today);
    let boundBookMinDate = func.dateBeforeSomeDays(10, today);
    let currentDate = date ? new Date(date).setHours(0, 0, 0, 0) : null;
    today = today.setHours(0, 0, 0, 0);
    technicalErrorMinDate = technicalErrorMinDate.setHours(0, 0, 0, 0);
    boundBookMinDate = boundBookMinDate.setHours(0, 0, 0, 0)
    if (currentDate >= today) {
      setPosState(posState => ({
        ...posState,
        subSequenceDelivType: ""
      }))
      return;
    }
    if (currentDate >= technicalErrorMinDate && currentDate < today) {
      setPosState(posState => ({
        ...posState,
        subSequenceDelivType: "SERVICE"
      }))
    }
    else if (currentDate >= boundBookMinDate && boundBookMinDate < today) {
      setPosState(posState => ({
        ...posState,
        subSequenceDelivType: "BOUNDBOOK"
      }))
    }
    else {
      setPosState(posState => ({
        ...posState,
        subSequenceDelivType: "NOINTERNET",
      }));
    }
  };


  const handleDueDateChange = (date) => {
    setPosState((invoiceState) => ({
      ...invoiceState,
      dueDate: date,
    }));
  };
  const subseqValues = [
    { value: "", label: "Select" },
    { value: "NOINTERNET", label: "No Internet" },
    { value: "BOUNDBOOK", label: "Boundbook" },
    { value: "SERVICE", label: "Service" },
    { value: "TECHNICALERROR", label: "Technical Error" },
  ];
  const popOver = {
    "NOINTERNET": t("hints.noInternet"),
    "BOUNDBOOK": t("hints.boundBook"),
    "SERVICE": t("hints.service"),
    "TECHNICALERROR": t("hints.TechnicalError"),
  }

  const CustomOption = ({ innerProps, isDisabled, label, data }) =>
    !isDisabled ? (
      <div className="option-custom-style"  {...innerProps}>
        {/* {label} <PopOver title={popoOver.find(popover=>popover.value==data.value).popoOver} /> */}
        {label} <PopOver title={popOver[data.value]} />
        {innerProps.label}
      </div>

    ) : null;

  const handleInvoiceBuyerChange = (e, selectKey, selectValue, length) => {
    let key = e ? e.target.name : selectKey;
    let value = e ? e.target.value : selectValue;
    if (key === "buyer") {
      let customer = value
      if (customer?.label && customer?.value) {
        delete customer["label"]
        delete customer["value"]
      }
      setPosState((posState) => ({
        ...posState,
        parties: {
          ...posState.parties,
          buyer: {
            tin: value?.idValue,
            name: value?.name,
            address: value?.address,
            country: func.getFullCountry(value?.country),
            town: value?.town,
            buyerIDType: posState.einvoice
            ? buyerIDTypes[0].label
            : !posState?.einvoice && customer?.idType
              ? customer?.idType
              : "ID",
            tin: (() => {
              if (posState.einvoice) return value?.idValue;
              if (!posState?.einvoice && customer?.idType) return value?.idValue;
              return "99999"; 
            })(),
            email: value?.email ?? null
          },
        },
      }));
      inputRef.current?.blur();
      inputRef.current?.focus();
    } else {
      value = length != undefined ? value.slice(0, length) : value;

      setPosState((posState) => ({
        ...posState,
        parties: {
          ...posState.parties,
          buyer: {
            ...posState?.parties?.buyer,
            [key]: value,
          },
        },
      }));
    }
  };


  const handleSubseqChange = (subseq) => {
    const { value, label } = subseq;
    setPosState((posState) => ({
      ...posState,
      subSequenceDelivType: value,
    }));

    var newDate = new Date();
    if (value === "BOUNDBOOK") {
      newDate = func.dateBeforeSomeDays(11, newDate);

    } else if (value === "SERVICE" || value === "TECHNICALERROR") {
      newDate = func.dateBeforeSomeDays(1, newDate);
    } else {
      newDate = func.getMinIssueDate();
    }
    const { issueDate } = posState;

    setMinIssueDate(newDate);

    if ((value === "BOUNDBOOK" || value === "SERVICE" || value === "TECHNICALERROR") && issueDate < newDate) {
      setPosState(posState => ({
        ...posState,
        issueDate: new Date(),
      }));
      issueDateRef.current.setOpen(true);
    }
  };

  const handleBusinessUnitCodeChange = async (businessUnitCode) => {
    const branch =
      branchesOptions?.find((branch) => branch.businUnitCode == businessUnitCode)

    // Check if branch is not active in CIS (skip for Create role - they only save drafts)
    if (branch && !branch.existCis && user.role.id !== 4) {
      const result = await Swal.fire({
        title: t(['notification.businessUnitNotActiveInCIS']),
        icon: 'warning',
        width: '800px',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        cancelButtonText: t(['common.cancel'])
      });

      if (!result.isConfirmed) {
        return;
      }
    }

      const orderedTcrs =
      (branch?.tcrTypes?.filter((tcrType) => {
        return tcrType?.allowInvoice;
      }) ?? [])
      .sort((a, b) => b.recordDate - a.recordDate);

      const tcrCode=orderedTcrs?.[0]?.tcrCode ?? ""

    const seller = branch ? {
      ...posState.parties.seller,
      address: branch.sellerAddress,
      country: countries.find((country) => country.label === branch.sellerCountry)
        ?.value || "Albania",
      town: branch.sellerTown,
      name: company.name,
    } : posState.parties.seller

    setPosState((posState) => ({
      ...posState,
      parties: { ...posState.parties, seller },
      businessUnitCode,
      tcrCode,
    }));
  };

  const handleChange = (key, value) => {
    if (key == "einvoice") {
      let paymentMethodType = "noncash"
      let buyerIDType = "NUIS"
      let tin = posState.parties.buyer.tin
      if (value == false) {
        if (posState.customer?.type) buyerIDType = buyerIDTypes.find(type => type.value == posState.customer?.type).label || "ID"
        else buyerIDType = "ID"
        paymentMethodType = "cash"
        tin = buyerIDType === "ID" ? "99999" : posState.parties.buyer.tin
      }
      setPosState(posState => ({
        ...posState,
        einvoice: value,
        paymentMethodType,
        parties: {
          ...posState.parties,
          buyer: {
            ...posState.parties.buyer,
            buyerIDType,
            tin,
          }
        },
      }))
      return
    }
    setPosState(posState => ({
      ...posState,
      [key]: value
    }))
  }
  const handleDiscountChange = (key, value) => {
    const discountValue = value;

    setPosState((posState) => ({
      ...posState,
      discount: {
        ...posState.discount,
        [key]: discountValue,
      },
    }));
  };

  const handleIicRefChange = (value) => {
    setPosState(state => ({
      ...state,
      iic_ref: value,
      refInvIIC: value,
    }))
  }

  const handleInputChanged = (input, reason, length) => {
    const {
      parties: { buyer },
    } = posState;

    if (reason?.action === "input-blur" || reason?.action === "menu-close") {
      return;
    } else if (reason?.action === "set-value") {
      return;
    } else {
      var value = length != undefined ? input.slice(0, length) : input;

      setPosState((posState) => ({
        ...posState,
        parties: {
          ...posState.parties,
          buyer: {
            ...buyer,
            name: value,
            town:value?.length==0 && posState?.parties?.buyer?.town==" " ? "" : posState?.parties?.buyer?.town,
          },
        },
      }));
    }
  };
  const currency = currenciesPos.find(currency => currency.value == (isEditPos ? posState.currency : persistedData.currency))


  const typeOfDiscountVatCategoryOptions = [
    { label: "0%", value: "0" },
    { label: "6%", value: "6" },
    { label: "10%", value: "10" },
    { label: "20%", value: "20" },
  ];

  const clearDialog=()=>setPartiesDialog({open:false,id:null,party:null,contact:null})


    const onNoCustomerChange= (e) => {
      const defaultBuyer= {
        tin: "99999", 
        name: "",
        address: "",
        country: "Albania",
        town: "",
        buyerIDType: "ID",
      }
      setPosState((state)=>({
        ...state,
        parties:{
          ...state.parties,
          buyer:hasNoCustomer ? defaultBuyer:{
              tin: "",
              name: "",
              address: "",
              country: "Albania",
              town: "",
              buyerIDType: null,
          }
        }
      }))
    }


  // ── Section-only rendering (for modal mode) ──
  if (section === "profile") {
    return (
      <div className="pos-modal-section">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">
              {t("home.branches")}
              <PopOver title={t("hints.branches")} />
            </label>
            <Select
              styles={selectStyle}
              options={branchesOptions}
              isSearchable={true}
              onChange={(branch) =>
                !disabled && handleBusinessUnitCodeChange(branch.businUnitCode)
              }
              value={branchesOptions?.find(
                (branch) => branch.businUnitCode === posState?.businessUnitCode
              )}
              isDisabled={disabled}
              name="tcrCode"
              menuPortalTarget={document.body}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">
              {t("home.tcr")}
            </label>
            <Select
              styles={selectStyle}
              options={tcrList}
              isSearchable={true}
              onChange={(tcr) => handleChange("tcrCode", tcr.value)}
              value={tcrList?.find((tcr) => tcr.value == posState.tcrCode) || ""}
              isDisabled={disabled}
              name="tcrCode"
              menuPortalTarget={document.body}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">{t("invoice.profileId")}</label>
            <Select
              styles={selectStyle}
              options={profileIdPos}
              isSearchable={true}
              onChange={(profileId) => {
                if (!disabled && isEditPos == false) setPersistedData({ ...persistedData, profileId: profileId.value });
                handleChange("profileId", profileId.value);
              }}
              value={profileIdPos.find(profileId => profileId.value == posState.profileId)}
              isDisabled={disabled}
              name="profileId"
              menuPortalTarget={document.body}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">{t("invoice.issueDate")}</label>
            <DatePicker
              ref={issueDateRef}
              selected={posState.issueDate}
              disabled={disabled}
              dateFormat="dd/MM/yyyy"
              name="issueDate"
              autoComplete="off"
              minDate={minIssueDate ? minIssueDate : func.getMinIssueDate()}
              showDisabledMonthNavigation
              onChange={handleIssueDateChange}
              customInput={<input className="form-control" />}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Subseq</label>
            <Select
              components={{ Option: CustomOption }}
              options={subseqValues}
              value={subseqValues.find(
                (subseq) => posState.subSequenceDelivType === subseq.value
              )}
              isDisabled={disabled}
              styles={selectStyle}
              onChange={(subseq) => handleSubseqChange(subseq)}
              name="subseq"
              menuPortalTarget={document.body}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">{t("invoice.paymentDate")}</label>
            <DatePicker
              selected={posState.dueDate}
              disabled={disabled}
              dateFormat="dd/MM/yyyy"
              name="dueDate"
              autoComplete="off"
              minDate={posState.issueDate}
              showDisabledMonthNavigation
              onChange={handleDueDateChange}
              customInput={<input className="form-control" />}
            />
          </div>
          {posState?.correctiveInv && isEditPos && (
            <div className="col-md-12">
              <label className="form-label">
                {t("purchases.iicRef")}
                <PopOver title={t("invoice.IICInvoiceCorreced")} />
              </label>
              <input
                name="iicRef"
                id="iicRef"
                type="text"
                className="form-control"
                disabled={disabled}
                value={posState.iic_ref}
                onChange={e => handleIicRefChange(e.target.value)}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  if (section === "currency") {
    return (
      <div className="pos-modal-section">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">
              {t("invoice.currency")}
              <PopOver title={t("hints.currencySelect")} />
            </label>
            <Select
              styles={selectStyle}
              options={currenciesPos}
              value={currenciesPos.find(
                (currency) => currency?.value === posState.currency
              )}
              isSearchable={true}
              onChange={(currency) => {
                if (!disabled && isEditPos == false) setPersistedData({ ...persistedData, currency: currency.value, rate: "1" });
                handleChange("currency", currency.value);
                handleChange("rate", "1");
              }}
              isDisabled={disabled}
              name="currency"
              menuPortalTarget={document.body}
            />
          </div>
          {posState?.currency !== "ALL" && (
            <div className="col-md-6">
              <label className="form-label">
                {t("home.exchangeRate")}
                <span className="text-danger"> *</span>
              </label>
              <div className="d-flex align-items-center gap-2">
                <input
                  name="rate"
                  type="number"
                  step="0.01"
                  min="0"
                  className="form-control"
                  value={posState.rate}
                  onChange={(e) => {
                    const value = e.target.value;
                    let count = func.countDecimals(value);
                    if (count > 6) return;
                    setIsUsingBoaRate(false);
                    if (!disabled && isEditPos == false)
                      setPersistedData({ ...persistedData, rate: value });
                    handleChange("rate", value);
                  }}
                  disabled={disabled}
                />
                <button
                  className="btn btn-sm btn-outline-primary flex-shrink-0"
                  onClick={getExchangeRates}
                  disabled={disabled || isEditPos}
                >
                  {t("home.getBoa")}
                </button>
              </div>
              {isUsingBoaRate && isRateBoaDateDifferent() && (
                <div className="text-success mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                  {t("common.lastUpdate")}: {rateBoaDate}
                </div>
              )}
              {!isUsingBoaRate && posState?.rate && boaExchangeRate && (() => {
                const rateDiff = calculateRateDifference();
                if (rateDiff) {
                  return (
                    <div className="text-warning mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                      {t("invoice.customExchangeRateWithDiff", {
                        percentage: rateDiff.percentage,
                        direction: t(`invoice.${rateDiff.direction}`)
                      }) || `Custom rate: ${rateDiff.percentage}% ${rateDiff.direction} than BOA`}
                    </div>
                  );
                }
                return (
                  <div className="text-warning mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                    {t("invoice.customExchangeRate") || "Using custom exchange rate"}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (section === "customer") {
    return (
      <div className="pos-modal-section">
        <div className="row g-3">
          <div className="col-12 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div className="d-flex align-items-center gap-3">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="isEinvoice"
                  name="isEinvoice"
                  checked={posState?.einvoice}
                  onChange={(e) => handleChange("einvoice", e.target.checked)}
                  disabled={disabled}
                />
                <label
                  style={{ paddingTop: "4px", paddingLeft: "2px" }}
                  htmlFor="isEinvoice"
                  className="custom-control-label"
                >
                  E-Invoice
                  <PopOver title={t("hints.einvoice")} />
                </label>
              </div>
              {!posState?.einvoice && (
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="noCustomer"
                    name="noCustomer"
                    disabled={disabled}
                    checked={hasNoCustomer}
                    onChange={onNoCustomerChange}
                  />
                  <label htmlFor="noCustomer" className="custom-control-label" style={{ paddingTop: "4px", paddingLeft: "2px" }}>
                    {t("invoice.noCustomer")}
                  </label>
                </div>
              )}
            </div>
            <button
              onClick={() => setPartiesDialog({ open: true, party: partiesDialogTypes.buyer })}
              className="btn btn-outline-primary btn-sm"
              style={{ borderRadius: "6px", fontSize: "0.8rem" }}
              disabled={disabled}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              {t("customers.addCustomer")}
            </button>
            <Dialog
              header={partiesDialog?.id ? t("mySuppliers.editContact") : t("mySuppliers.addContact")}
              visible={buyerVisible}
              onHide={() => clearDialog()}
              style={{ width: "900px", minHeight: "90%" }}
              breakpoints={{ "960px": "80vw", "641px": "95vw" }}
            >
              {buyerVisible &&
                <EditAddSupplies
                  fromInvoice={true}
                  onDataSuccess={(contact) => {
                    handleInvoiceBuyerChange(null, 'buyer', contact);
                    clearDialog();
                  }}
                />
              }
            </Dialog>
          </div>
          <div className="col-md-6">
            <label className="form-label">
              {t("customers.name")}
              <span className="text-danger"> *</span>
            </label>
            <AsyncSelect
              key={i18n.language}
              styles={selectStyle}
              name="buyer"
              onFocus={handleFocus}
              ref={inputRef}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
              className="basic-multi-select"
              onChange={(value) => {
                handleInvoiceBuyerChange(null, "buyer", value);
                setBuyerValue(value);
                setBuyerInputValue(value?.name || "");
              }}
              cacheOptions
              value={buyerValue}
              inputValue={buyerInputValue}
              loadOptions={loadOptionsForContacts}
              defaultOptions={false}
              onInputChange={(input, reason) => {
                handleInputChanged(input, reason, 200);
                if (reason?.action !== "input-blur" && reason?.action !== "menu-close" && reason?.action !== "set-value") {
                  setBuyerInputValue(input);
                }
              }}
              isDisabled={disabled}
              isClearable={true}
              menuPortalTarget={document.body}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">{t("pos.idType")}</label>
            <Select
              styles={selectStyle}
              options={posState.einvoice == false ? buyerIDTypesParsed : [buyerIDTypesParsed[1]]}
              value={buyerIDTypesParsed.find(
                (type) => type.name === posState?.parties?.buyer?.buyerIDType
              )}
              isSearchable={true}
              onChange={(buyerIDtype) => {
                handleInvoiceBuyerChange(null, "buyerIDType", buyerIDtype.name);
                if (buyerIDtype.name === "ID") {
                  handleInvoiceBuyerChange(null, "tin", "99999");
                } else {
                  handleInvoiceBuyerChange(null, "tin", "");
                }
              }}
              isDisabled={disabled}
              name="buyerIdType"
              menuPortalTarget={document.body}
            />
          </div>
          {posState?.parties?.buyer?.buyerIDType != null && (
            <div className="col-md-6">
              <label className="form-label">
                {posState?.parties?.buyer?.buyerIDType}
                <span className="text-danger"> *</span>
              </label>
              <input
                name="tin"
                type="text"
                className="form-control"
                value={posState?.parties?.buyer?.tin}
                onChange={(e) => handleInvoiceBuyerChange(e, null, null, 20)}
                disabled={disabled || hasNoCustomer}
              />
            </div>
          )}
          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              name="email"
              type="email"
              className="form-control"
              value={posState?.parties?.buyer?.email}
              onChange={(e) => handleInvoiceBuyerChange(e, null, null, 50)}
              disabled={disabled || hasNoCustomer}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">
              {t("taxpayer.city")}
              <span className="text-danger"> *</span>
            </label>
            <input
              name="town"
              type="text"
              className="form-control"
              value={posState?.parties?.buyer?.town}
              onChange={(e) => handleInvoiceBuyerChange(e, null, null, 50)}
              disabled={disabled || hasNoCustomer}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">
              {t("invoice.discount")}
              <PopOver title={t("hints.invoiceDiscount")} />
            </label>
            <div className="input-group">
              <input
                type={disabled ? "text" : "number"}
                step="0.01"
                min="0.01"
                id="discount"
                name="discount"
                className="form-control form-control-sm"
                disabled={disabled || hasNoCustomer}
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e') e.preventDefault();
                }}
                value={
                  disabled
                    ? posState.discount
                      ? formatNumber(posState.discount?.value || null)
                      : ""
                    : posState.discount?.value
                }
                onChange={(e) => handleDiscountChange("value", e.target.value)}
              />
              <div className="input-group-append dropup">
                <button
                  className={"btn btn-sm btn-outline-primary dropdown-toggle" + (disabled ? " disabled" : "")}
                  style={{ height: "29px" }}
                  disabled={disabled}
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {posState?.discount?.type == "Percentage" ? "%" : posState?.currency}
                </button>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#" disabled={disabled} onClick={(e) => { e.preventDefault(); handleDiscountChange("type", "Percentage"); }}>
                    {t("invoice.percentage")}
                  </a>
                  <a className="dropdown-item" disabled={disabled || hasNoCustomer} href="#" onClick={(e) => { e.preventDefault(); handleDiscountChange("type", "value"); }}>
                    {t("invoice.value")}
                  </a>
                </div>
              </div>
            </div>
            <label htmlFor="discountVat" className="field-label mt-2">
              {t("invoice.discountVat")}
              <PopOver title={t("hints.discountVat")} discountVat />
            </label>
            <Select
              menuPlacement='top'
              styles={selectStyle}
              id="discountVat"
              name="discountVat"
              options={typeOfDiscountVatCategoryOptions}
              value={
                typeOfDiscountVatCategoryOptions.find(
                  (dVat) => dVat.value === posState.discount.vat
                ) || null
              }
              onChange={(e) => handleDiscountChange("vat", e.value)}
              isDisabled={disabled || hasNoCustomer}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>
    );
  }

  // ── Default: full accordion layout (used by EditPos) ──
  return (
    <div className="col-12">
      <div className="row align-items-start flex-md-nowrap g-0">
        {disabled && isEditPos && <div className="card border-0 col-12 col-md-4">
          <InvoicePrintInfo invoice={posState} preview={printInvoice} />
        </div>}
        <div className={`card border col-12 ${disabled ? "col-md-2" : "col-md"}`} style={{ overflow: "hidden" }}>
          <Accordion
            overflow={true}
            heading={
              <div className="d-flex border-0 align-items-center">
                <h4 className="mb-0" style={{ fontSize: "0.95rem" }}> Profile ID · {!disabled && isEditPos == false ? persistedData.profileId : posState?.profileId}</h4>
                {posState.cisStatus && !disabled &&
                  <>
                    <Tooltip target=".error-tooltip" />
                    {posState.cisError ? (
                  <small
                  className={`error-tooltip badge badge-${isRefreshStatus(posState)?"warning":"danger"} d-inline-flex align-items-center ms-2`} style={{zIndex:100000000}}
                  data-pr-tooltip={posState?.cisError}
                  data-pr-position="right"
                  data-pr-my="left center-2"
              >
                  {isRefreshStatus(posState)? <span style={{fontWeight:600}}>PENDING</span> :"Error"}
                  <FontAwesomeIcon icon={faQuestionCircle} className="ms-2" />
              </small>
                    ) : (
                      <small className="badge badge-danger ms-2">Error</small>
                    )}
                  </>
                }
              </div>
            }
          >
            <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                {t("home.branches")}
                <PopOver title={t("hints.branches")} />
              </label>
              <Select
                styles={selectStyle}
                options={branchesOptions}
                isSearchable={true}
                onChange={(branch) =>
                  !disabled && handleBusinessUnitCodeChange(branch.businUnitCode)
                }
                value={branchesOptions?.find(
                  (branch) =>
                    branch.businUnitCode === posState?.businessUnitCode
                )}
                isDisabled={disabled}
                name="tcrCode"
              />
            </div>
            <div className="col-md-12 mb-2">
              <label className="form-label mb-0 ">
                {t("home.tcr")}
              </label>
              <Select
                styles={selectStyle}
                options={tcrList}
                isSearchable={true}
                onChange={(tcr) => { 
                  // if (!disabled && isEditPos == false) setPersistedData({ ...persistedData, tcrCode: tcr.value });
                   handleChange("tcrCode", tcr.value) }}
                value={
                  tcrList?.find((tcr) => tcr.value == posState.tcrCode) ||
                  ""
                }
                isDisabled={disabled}
                name="tcrCode"
              />
            </div>
            <div className="col-md-12 mb-2">
              <label className="form-label"> {t("invoice.profileId")}
              </label>

              <Select
                styles={selectStyle}
                options={profileIdPos}
                isSearchable={true}
                onChange={(profileId) => { if (!disabled && isEditPos == false) setPersistedData({ ...persistedData, profileId: profileId.value }); handleChange("profileId", profileId.value) }}
                value={profileIdPos.find(profileId => profileId.value == posState.profileId)}
                isDisabled={disabled}
                name="profileId"

              />
            </div>
            <div className="col-md-12 mb-2">
              <label className="form-label">
                {t("invoice.issueDate")}
              </label>
              <DatePicker
                ref={issueDateRef}
                selected={posState.issueDate}
                disabled={disabled}
                dateFormat="dd/MM/yyyy"
                name="issueDate"
                autoComplete="off"
                minDate={minIssueDate ? minIssueDate : func.getMinIssueDate()}
                showDisabledMonthNavigation
                onChange={handleIssueDateChange}
                customInput={<input className="form-control" />}
              />
            </div>
            <div className="col-md-12 mb-2">
              <label className="form-label">
                Subseq
              </label>
              <Select

                components={{ Option: CustomOption }}
                options={subseqValues}
                value={subseqValues.find(
                  (subseq) => posState.subSequenceDelivType === subseq.value
                )}
                isDisabled={disabled}
                styles={selectStyle}
                onChange={(subseq) => handleSubseqChange(subseq)}
                name="subseq"
              />
            </div>

            <div className="col-md-12 mb-2">
              <label className="form-label">
                {t("invoice.paymentDate")}
              </label>
              <DatePicker
                selected={posState.dueDate}
                disabled={disabled}
                dateFormat="dd/MM/yyyy"
                name="dueDate"
                autoComplete="off"
                minDate={posState.issueDate}
                showDisabledMonthNavigation
                onChange={handleDueDateChange}
                customInput={<input className="form-control" />}
              />
            </div>
            {posState?.correctiveInv && isEditPos && <div className="col-md-12 mb-2">
              <label className="form-label mt-2">
                {t("purchases.iicRef")}
                <PopOver title={t("invoice.IICInvoiceCorreced")} />
              </label>
              <input
                name="iicRef"
                id="iicRef"
                type="text"
                className="form-control"
                disabled={disabled}
                value={posState.iic_ref}
                onChange={e => handleIicRefChange(e.target.value)}
              />
            </div>}
          </Accordion>
        </div>

        <div className={`card border col-12 ${disabled ? "col-md-2" : "col-md"}`} style={{ overflow: "hidden" }}>
          <Accordion
            overflow={true}
            heading={
              <div className="d-flex border-0 align-items-center">
                <h4 className="mb-0" style={{ fontSize: "0.95rem" }}> {currency.value} {currency.value != 'ALL' && (" · " + posState.rate)} </h4>
              </div>
            }
          >

            <div className="col-md-12 mb-4">
              <label className="form-label mb-0">
                {t("invoice.currency")}
                <PopOver title={t("hints.currencySelect")} />
              </label>
              <Select
                styles={selectStyle}
                options={currenciesPos}
                value={currenciesPos.find(
                  (currency) => currency?.value === posState.currency
                )}
                isSearchable={true}
                onChange={(currency) => { if (!disabled && isEditPos == false) setPersistedData({ ...persistedData, currency: currency.value, rate: "1" }); handleChange("currency", currency.value); handleChange("rate", "1") }
                }
                isDisabled={disabled}
                name="currency"
              />
            </div>

            <div className="col-md-10">
              {posState?.currency !== "ALL" && (
                <>
                  <label className="form-label mb-0">
                    {t("home.exchangeRate")}
                    <span className="text-danger"> *</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <input
                      name="rate"
                      type="number"
                      step="0.01"
                      min="0"
                      style={isEditPos ? { width: "100px" } : {}}
                      className="form-control mr-2"
                      value={posState.rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        let count = func.countDecimals(value);
                        if (count > 6) return;
                        setIsUsingBoaRate(false);
                        if (!disabled && isEditPos == false)
                          setPersistedData({ ...persistedData, rate: value });
                        handleChange("rate", value);
                      }}
                      disabled={disabled}
                    />
                    <button
                      className="btn btn-sm btn-outline-primary flex-shrink-0"
                      onClick={getExchangeRates}
                      disabled={disabled || isEditPos}
                    >
                      {t("home.getBoa")}
                    </button>
                  </div>
                  <div>
                    {isUsingBoaRate && isRateBoaDateDifferent() && (
                      <div className="text-success mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                        {t("common.lastUpdate")}: {rateBoaDate}
                      </div>
                    )}
                    {!isUsingBoaRate && posState?.rate && boaExchangeRate && (() => {
                      const rateDiff = calculateRateDifference();
                      if (rateDiff) {
                        return (
                          <div className="text-warning mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                            {t("invoice.customExchangeRateWithDiff", {
                              percentage: rateDiff.percentage,
                              direction: t(`invoice.${rateDiff.direction}`)
                            }) || `You are using your own exchange rate that is ${rateDiff.percentage}% ${rateDiff.direction} than the default BOA exchange rate`}
                          </div>
                        );
                      }
                      return (
                        <div className="text-warning mt-2 font-weight-bold" style={{ fontSize: "13px" }}>
                          {t("invoice.customExchangeRate") || "You are using your own exchange rate"}
                        </div>
                      );
                    })()}
                  </div>
                </>
              )}
            </div>


          </Accordion>
        </div>
        <div className={`card border col-12 ${disabled ? "col-md-4" : "col-md"}`} style={{ overflow: "hidden" }}>
          <Accordion
            overflow={false}
            heading={

              <div className="d-flex border-0 mt-0 pt-0 align-items-center flex-wrap">
                <h4 className="mb-0" style={{ fontSize: "0.95rem", whiteSpace: "nowrap" }}> {posState.parties.buyer.name || t("navbar.customers")}</h4>
                <div className="d-flex align-items-center ms-2 flex-wrap" style={{ gap: "0.5rem 1rem" }}>
                  <div className="custom-control align-items-center custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="isEinvoice"
                      name="isEinvoice"
                      checked={posState?.einvoice}
                      onChange={(e) =>
                        handleChange("einvoice", e.target.checked)
                      }
                      disabled={disabled}
                    />
                    <label
                      style={{ paddingTop: "4px", paddingLeft: "2px", fontSize: "0.8rem" }}
                      htmlFor="isEinvoice"
                      className="custom-control-label"
                    >
                      E-Invoice
                      <PopOver title={t("hints.einvoice")} />
                    </label>
                  </div>
                  {!posState?.einvoice && <div className="custom-control align-items-center custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="noCustomer"
                      name="noCustomer"
                      disabled={disabled}
                      checked={hasNoCustomer}
                      onChange={onNoCustomerChange}
                    />
                    <label htmlFor="noCustomer" className="custom-control-label" style={{ paddingTop: "4px", paddingLeft: "2px", fontSize: "0.8rem" }} >
                      {t("invoice.noCustomer")}
                    </label>
                  </div>}
                </div>

              </div>
            }
          >

            <div className="mb-3 d-flex align-items-center justify-content-between">
              <button
                onClick={() => setPartiesDialog({ open: true, party: partiesDialogTypes.buyer })}
                className="btn btn-outline-primary btn-sm ms-3"
                style={{ borderRadius: "6px", fontSize: "0.8rem" }}
                disabled={disabled}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" />
                {t("customers.addCustomer")}
              </button>
              <Dialog
                header={partiesDialog?.id ? t("mySuppliers.editContact") : t("mySuppliers.addContact")}
                visible={buyerVisible}
                onHide={() => clearDialog()}
                style={{ width: "900px", minHeight: "90%" }}
                breakpoints={{ "960px": "80vw", "641px": "95vw" }}
              >
              {buyerVisible && 
              <EditAddSupplies
                fromInvoice={true}
                onDataSuccess={(contact)=>{
                  handleInvoiceBuyerChange(null, 'buyer', contact);
                  clearDialog()
                }}
              />
              
              // <EditCustomer
              //   invoiceState={posState}
              //   setInvoiceState={setPosState}
              //   isNew={true}
              //   onCustomerUpdate={(customer) => {
              //     handleInvoiceBuyerChange(null, 'buyer', customer);
              //     clearDialog()
              //   }}
              //   />
                }
                </Dialog>
            </div>

            <div className="col-md-12 mb-2">

              <label className="form-label mb-0">
                {" "}
                {t("customers.name")}
                <span className="text-danger"> *</span>
              </label>
              <AsyncSelect
                key={i18n.language}
                styles={selectStyle}
                name="buyer"
                onFocus={handleFocus}
                ref={inputRef}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                className="basic-multi-select"
                onChange={(value) => {
                  handleInvoiceBuyerChange(null, "buyer", value);
                  setBuyerValue(value);
                  setBuyerInputValue(value?.name || "");
                }}
                cacheOptions
                value={buyerValue}
                inputValue={buyerInputValue}
                loadOptions={loadOptionsForContacts}
                defaultOptions={false}
                onInputChange={(input, reason) => {
                  handleInputChanged(input, reason, 200);
                  if (reason?.action !== "input-blur" && reason?.action !== "menu-close" && reason?.action !== "set-value") {
                    setBuyerInputValue(input);
                  }
                }}
                isDisabled={disabled}
                isClearable={true}
              />
            </div>
            <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                {t("pos.idType")}
              </label>
              <Select
                styles={selectStyle}
                options={posState.einvoice == false ? buyerIDTypesParsed : [buyerIDTypesParsed[1]]}
                value={buyerIDTypesParsed.find(
                  (type) =>
                    type.name === posState?.parties?.buyer?.buyerIDType
                )}
                isSearchable={true}
                onChange={(buyerIDtype) => {
                  handleInvoiceBuyerChange(null, "buyerIDType", buyerIDtype.name);
                  if (buyerIDtype.name === "ID") {
                    handleInvoiceBuyerChange(null, "tin", "99999");
                  } else {
                    handleInvoiceBuyerChange(null, "tin", "");
                  }
                }}
                isDisabled={disabled}
                name="buyerIdType"
              />
            </div>
            {posState?.parties?.buyer?.buyerIDType !=null && <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                {posState?.parties?.buyer?.buyerIDType}
                <span className="text-danger"> *</span>
              </label>
              <div>
                <div className="input-length-validation">
                  <input
                    name="tin"
                    type="text"
                    className="form-control"
                    value={posState?.parties?.buyer?.tin}
                    onChange={(e) =>
                      handleInvoiceBuyerChange(e, null, null, 20)
                    }
                    disabled={disabled || hasNoCustomer}
                  />
                  <div className={`length-text : ""}`}>
                    {posState?.parties?.buyer?.tin?.length == 20
                      ? "text-danger"
                      : ""}
                  </div>
                </div>
              </div>
            </div>}

            <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                Email
              </label>
              <div>
                <div className="input-length-validation">
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    value={posState?.parties?.buyer?.email}
                    onChange={(e) =>
                      handleInvoiceBuyerChange(e, null, null, 50)
                    }
                    disabled={disabled || hasNoCustomer}
                  />
                  <div className={`length-text : ""}`}>
                    {posState?.parties?.buyer?.email?.length == 50
                      ? "text-danger"
                      : ""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                {t("taxpayer.city")}
                <span className="text-danger"> *</span>
              </label>
              <div>
                <div className="input-length-validation">
                  <input
                    name="town"
                    type="town"
                    className="form-control"
                    value={posState?.parties?.buyer?.town}
                    onChange={(e) =>
                      handleInvoiceBuyerChange(e, null, null, 50)
                    }
                    disabled={disabled || hasNoCustomer}
                  />
                  <div className={`length-text : ""}`}>
                    {posState?.parties?.buyer?.town?.length == 50
                      ? "text-danger"
                      : ""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-2">
              <label className="form-label mb-0">
                {t("invoice.discount")}

                <PopOver title={t("hints.invoiceDiscount")} />
              </label>
              <div className="input-group">
                <input
                  type={disabled ? "text" : "number"}
                  step="0.01"
                  min="0.01"
                  id="discount"
                  name="discount"
                  className="form-control form-control-sm"
                  disabled={disabled || hasNoCustomer}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                  value={
                    disabled
                      ? posState.discount
                        ? formatNumber(posState.discount?.value || null)
                        : ""
                      : posState.discount?.value
                  }
                  onChange={(e) => handleDiscountChange("value", e.target.value)}
                />
                <div className="input-group-append dropup">
                  <button
                    className={
                      "btn btn-sm btn-outline-primary dropdown-toggle" +
                      (disabled ? " disabled" : "")
                    }
                    style={{ height: "29px" }}
                    disabled={disabled}
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {posState?.discount?.type == "Percentage" ? "%" : posState?.currency}
                  </button>
                  <div className="dropdown-menu">
                    <a
                      className="dropdown-item"
                      href="#"
                      disabled={disabled}
                      onClick={(e) => {
                        e.preventDefault();
                        handleDiscountChange("type", "Percentage");
                      }}
                    >
                      {t("invoice.percentage")}
                    </a>
                    <a
                      className="dropdown-item"
                      disabled={disabled || hasNoCustomer}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDiscountChange("type", "value");
                      }}
                    >
                      {t("invoice.value")}
                    </a>
                  </div>
                </div>
              </div>
              <label htmlFor="discountVat" className="field-label">
                {t("invoice.discountVat")}
                <PopOver title={t("hints.discountVat")} discountVat />
              </label>

              <Select
                menuPlacement='top'
                styles={selectStyle}
                id="discountVat"
                name="discountVat"
                options={typeOfDiscountVatCategoryOptions}
                value={
                  typeOfDiscountVatCategoryOptions.find(
                    (dVat) => dVat.value === posState.discount.vat
                  ) || null
                }
                onChange={(e) => handleDiscountChange("vat", e.value)}
                isDisabled={disabled || hasNoCustomer}
              />
            </div>

          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default PosDetails;
